import OcupationEntry from './Ocupation';

export default OcupationEntry;
